import React, { useContext } from 'react';
import FooterBackground from './FooterBackground';
import LinkSection from './LinkSection';
import {
  Link,
  FlexGrid,
  FlexGridItem,
  ResponsiveContext,
  Text,
} from '@alinta-digital/asg';
import Gradient from './Gradient';

interface AppFooterProps {
  phone?: string;
}

const textColor = 'rgba(255, 255, 255, 1)';

const links = [
  {
    label: 'Privacy',
    href:
      'https://www.alintaenergy.com.au/help-and-support/terms-and-conditions/privacy-policy',
  },
  {
    label: 'Terms and Conditions',
    href:
      'https://www.alintaenergy.com.au/help-and-support/terms-and-conditions',
  },
];

const AppFooter: React.FC<AppFooterProps> = () => {
  const currentSize = useContext(ResponsiveContext);
  const isXsScreen = currentSize === 'xs';
  const itemPadding = isXsScreen
    ? { top: 'xsmall', bottom: 'xsmall' }
    : { left: 'medium' };
  return (
    <FooterBackground aria-label="standard footer">
      <Gradient />
      <LinkSection>
        <FlexGrid
          alignItems={isXsScreen ? 'start' : 'center'}
          direction={isXsScreen ? 'column' : 'row'}
        >
          {links.map(({ label, href }, index) => (
            <FlexGridItem xs="auto" pad={itemPadding} key={index}>
              <Link
                size="18px"
                href={href}
                textUnderline={false}
                color={textColor}
              >
                {label}
              </Link>
            </FlexGridItem>
          ))}
          <FlexGridItem xs="auto" pad={itemPadding}>
            <Text size="18px" color={textColor}>
              © Alinta Energy {new Date().getFullYear()}
            </Text>
          </FlexGridItem>
        </FlexGrid>
      </LinkSection>
    </FooterBackground>
  );
};

export default AppFooter;
